export default __webpack_public_path__ + "static/media/tumble-dryer.724412fd.svg";